var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header class=\"page-title\"><h1>{{vm.$title}}</h1></header><section class=\"main col-lg-12\"><p>{{vm.$message}}</p></section>");;return buf.join("");
}